module.exports = __webpack_public_path__ + "static/media/macbook_ratatool_fr.5ec0e30e.png";